import { getBookInfo } from '@skjv/common';
/**
 * jsPDF's built-in Helvetica is WinAnsi-only — native Greek/Hebrew script,
 * smart punctuation, and markdown italics render as mojibake and break glyph
 * metrics (letter-spaced, overflowing lines). Reduce to printable ASCII:
 * lexicon tie-ins keep their phonetic, smart punctuation transliterates,
 * everything else non-ASCII is dropped.
 */
export function sanitizePdfText(text) {
    return text
        // "νόμος (*nom'-os*)" → "nom'-os": drop native script, keep the phonetic
        .replace(/[^\x00-\x7F]+\s*\(\*([^*]+)\*\)/g, '$1')
        .replace(/\(\*([^*]+)\*\)/g, '($1)')
        .replace(/\*/g, '')
        .replace(/[‘’′]/g, "'")
        .replace(/[“”″]/g, '"')
        .replace(/[–—―]/g, '-')
        .replace(/…/g, '...')
        .replace(/[^\x20-\x7E\n]/g, '')
        .replace(/ {2,}/g, ' ')
        .replace(/\( /g, '(')
        .replace(/ \)/g, ')');
}
export function getLocationTitle(startingLocation, endingLocation) {
    let title = `Ch ${startingLocation.chapterIndex + 1}`;
    if (endingLocation) {
        if (startingLocation.chapterIndex === endingLocation.chapterIndex) {
            title = `${title} v${startingLocation.verseIndex + 1}-${endingLocation.verseIndex + 1}`;
        }
        else {
            title = `${title} v${startingLocation.verseIndex + 1} - Ch ${endingLocation.chapterIndex + 1} v${endingLocation.verseIndex + 1}`;
        }
    }
    else {
        title = `${title} v${startingLocation.verseIndex + 1}`;
    }
    return title;
}
export function getBookAbbrev(location) {
    const book = getBookInfo(location.testamentIndex, location.bookIndex);
    return book?.abbrev || 'Unknown';
}
export function drawWritingLines(doc, startY, lineCount, marginSize, padding, pageWidth) {
    let currentY = startY;
    for (let i = 0; i < lineCount; i++) {
        doc.line(marginSize + padding, currentY, pageWidth - marginSize - padding, currentY);
        currentY = currentY + 10;
    }
    return currentY;
}
//# sourceMappingURL=pdf-helpers.js.map